<template>
  <PopupTemplate @close="close()">
    <div>
      <h2>{{ asunto }}</h2>
      <p>
        {{ mensaje }}
      </p>
    </div>
  </PopupTemplate>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable */

export default {
  props: {
    asunto: { type: String, required: true, default: null },
    mensaje: { type: String, required: true, default: null },
  },

  data() {
    return {
      asunto: this.asunto,
      mensaje: this.mensaje,
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped></style>
